import { ThemeProvider } from "@mui/material/styles";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import { theme } from "./colorTheme";
import NoPage from "./components/pages/NoPage";
import OnboardingPage from "./components/pages/OnboardingPage/OnboardingPage";
import AdminPage from "./components/pages/AdminPage";
import HomePage from "./components/pages/HomePage";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import LoginPage from "./components/pages/LoginPage";
import { forceRefreshTokens } from "./utils/Fetching";
import { useEffect } from "react";

export default function App() {
  const { instance } = useMsal();

  useEffect(() => {
    const refreshTokensAfterTime = () => {
      forceRefreshTokens(instance);
    };
    const interval = setInterval(refreshTokensAfterTime, 2700000);
    return () => clearInterval(interval);
  }, [instance]);
  return (
    <>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <AuthenticatedTemplate>
            <Routes>
              <Route path="">
                <Route path="/" element={<HomePage />} />
                <Route path="*" element={<NoPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/onboarding" element={<OnboardingPage />} />
              </Route>
            </Routes>
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
            <LoginPage />
          </UnauthenticatedTemplate>
        </BrowserRouter>
      </ThemeProvider>
    </>
  );
}
